<div class="content-box unit">
  <div class="content-head" [class.mb-16]="pureTitle">
    <!-- 标题 -->
    @if (!pureTitle) {
      <ng-container *ngIf="title; else titleSkeleton">
        @if (titleHref) {
          <a [href]="domain + titleHref" (click)="clickTitle.emit(); $event.preventDefault()">
            <span class="title mutual-opacity onact96">
              <img *ngIf="titleIcon" [src]="titleIcon" />
              <span> {{ title }}</span>
            </span>
          </a>
        } @else {
          <span class="title">
            <img *ngIf="titleIcon" [src]="titleIcon" />
            <span> {{ title }}</span>
          </span>
        }
      </ng-container>
      <ng-template #titleSkeleton>
        <div class="title skeleton-loading" style="width: 30%; height: 100%"></div>
      </ng-template>
    } @else {
      <div class="section-title">{{ pureTitle }}</div>
    }
    <ng-container *ngIf="data && data.length > 0; else arrowSkeleton">
      <div class="wrap">
        <!-- view all btn -->
        <div
          (click)="clickTitle.emit(); $event.preventDefault()"
          class="view-all-btn"
          *ngIf="redirectMethod === 'LabelPage'"
        >
          {{ 'view_all_lower' | translate }} ({{ count }})
        </div>
        <!-- web/desktop版本顯示左右箭頭 -->
        <!-- 沒有View all(等於titleHref沒有值)也顯示左右箭頭-->
        <!-- 如果要強製讓他顯示箭頭就使用showArrowGroupH5=true -->
        <div class="arrow-group" *ngIf="!isH5 || !titleHref || showArrowGroupH5">
          <!-- 上一页 -->
          <div class="control-left onact96" [class.disable]="imgCarousel.isBeginning" (click)="imgCarousel.slidePrev()">
            <i class="fi-arrow-left-filled"></i>
          </div>
          <!-- 下一页 -->
          <div class="control-right onact96" [class.disable]="imgCarousel.isEnd" (click)="imgCarousel.slideNext()">
            <i class="fi-arrow-right-filled"></i>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #arrowSkeleton>
      <div class="arrow-group skeleton-loading" style="width: 20%; height: 100%"></div>
    </ng-template>
  </div>
  <ng-content select="[name=under-header]"></ng-content>
  <div class="content-body" #contentBody>
    <app-img-carousel #imgCarousel [config]="imgCarouselConfig" [itemsData]="renderData() | sliceArray: row || 0">
      <ng-template #carouselItemTpl let-item let-index="index">
        <ng-container [ngSwitch]="for">
          <ng-container *ngSwitchCase="'game'">
            <!-- 多行显示 -->
            <ng-container *ngIf="row && row > 1; else singleItem">
              <div class="item-group">
                <ng-container *ngFor="let subItem of item; let i = index">
                  <app-game-unit
                    [ratio]="ratio"
                    [isProvider]="isProvider"
                    [item]="subItem"
                    [hasHover]="hasHover"
                    [hasMask]="hasMask"
                    [style.margin-top]="i == 0 ? '' : imgCarousel.spaceBetween - 20 + 'px'"
                    [hasFavorite]="hasFavorite"
                    (beforeClickItem)="beforeClickItem.emit()"
                    (clickItem)="clickItem.emit($event)"
                    (afterClickItem)="afterClickItem.emit()"
                    (clickOnDisabled)="imgCarousel.isEnd ? imgCarousel.slidePrev() : imgCarousel.slideNext()"
                  ></app-game-unit>
                </ng-container>
              </div>
            </ng-container>
            <!-- 单行 -->
            <ng-template #singleItem>
              <app-game-unit
                [ratio]="ratio"
                [isProvider]="isProvider"
                [item]="item"
                [hasHover]="hasHover"
                [hasMask]="hasMask"
                [hasFavorite]="hasFavorite"
                (beforeClickItem)="beforeClickItem.emit()"
                (clickItem)="clickItem.emit($event)"
                (afterClickItem)="afterClickItem.emit()"
                (clickOnDisabled)="imgCarousel.isEnd ? imgCarousel.slidePrev() : imgCarousel.slideNext()"
              ></app-game-unit>
            </ng-template>
          </ng-container>
          <ng-container *ngSwitchCase="'ongoing'">
            <app-ongoing-unit [item]="item"></app-ongoing-unit>
          </ng-container>
          <ng-container *ngSwitchCase="'sport'">
            <app-sport-unit [item]="item" [index]="index"></app-sport-unit>
          </ng-container>
          <ng-container *ngSwitchCase="'winner'">
            <app-latest-winner-unit
              [item]="item"
              [index]="index"
              (beforeClickItem)="beforeClickItem.emit()"
              (clickItem)="clickItem.emit($event)"
              (afterClickItem)="afterClickItem.emit()"
              (clickOnDisabled)="imgCarousel.isEnd ? imgCarousel.slidePrev() : imgCarousel.slideNext()"
              [isFiatDisplay]="isFiatDisplay"
            ></app-latest-winner-unit>
          </ng-container>
        </ng-container>
      </ng-template>
    </app-img-carousel>
  </div>
</div>
